import { getParentTypeLabel, isParentType } from './parentObjectTypes';

// Starter list of object types. Extend as needed.
export const objectTypes = [
  'fortification',
  'mound',
  'wall',
  'ditch',
  'building',
  'structure',
  'boundary',
  'vegsign',
  'viereckschanze',
  'pit',
  'pit-house',
  'enclosure',
  'grave',
  'rondel',
  'rondeloid',
  'deposit_site',
  'other',
] as const;

export type ObjectType = typeof objectTypes[number];

export const objectTypeLabels: Record<ObjectType, string> = {
  fortification: 'Fortification',
  mound: 'Mound',
  wall: 'Wall',
  ditch: 'Ditch',
  building: 'Building',
  structure: 'Structure',
  boundary: 'Boundary',
  vegsign: 'Vegetation sign',
  viereckschanze: 'Viereckschanze',
  pit: 'Pit',
  'pit-house': 'Pit house',
  enclosure: 'Enclosure',
  grave: 'Grave',
  rondel: 'Rondel',
  rondeloid: 'Rondeloid',
  deposit_site: 'Deposit site',
  other: 'Other',
};

// Resolves the display label for any stored object type, parent or regular.
// Falls back to the raw key so unknown/legacy values still render.
export function getObjectTypeLabel(type?: string | null): string | null {
  if (!type) return null;
  if (isParentType(type)) return getParentTypeLabel(type);
  return objectTypeLabels[type as ObjectType] ?? type;
}
